import * as React from 'react';
/**
 *
 * Original name: upload folder
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A523
 *
 */
export const UploadFolderSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "m58.478 30-6.1-7.926A13.078 13.078 0 0 0 42.076 17H13v69a13.015 13.015 0 0 0 13 13h68a13.015 13.015 0 0 0 13-13V30H58.478ZM101 86a7.006 7.006 0 0 1-7 7H26a7.008 7.008 0 0 1-7-7V23h23.076a7.04 7.04 0 0 1 5.548 2.732L55.522 36H101v50Z", fill: "currentColor" }),
    React.createElement("path", { d: "m45.658 59.317 2.684 5.366A38.931 38.931 0 0 0 57 58.443V82h6V58.443a38.93 38.93 0 0 0 8.658 6.241l2.688-5.364C74.257 59.274 65.568 54.745 63 48h-6c-2.568 6.745-11.257 11.274-11.342 11.317Z", fill: "currentColor" })));
